"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cellClassFactory = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var ts_invariant_1 = require("ts-invariant");
var tableDescriptorTypes_1 = require("../structure/tableDescriptorTypes");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var constants_1 = require("../base/constants");
var cellDrillabilityPredicate_1 = require("../drilling/cellDrillabilityPredicate");
var last_1 = tslib_1.__importDefault(require("lodash/last"));
var cellUtils_1 = require("./cellUtils");
function cellClassFactory(table, props, classList) {
    return function (cellClassParams) {
        var rowIndex = cellClassParams.rowIndex, data = cellClassParams.data;
        var row = data;
        var isEmptyCell = !cellClassParams.value;
        // hide empty sticky cells
        var isTopPinned = cellClassParams.node.rowPinned === "top";
        if (isEmpty_1.default(row)) {
            // ag-grid calls getCellClass before the data is available & rows are created - there will be no
            // data in the cellClassParams. not sure what is the purpose or whether that is a bug. anyway it
            // does not make sense to proceed further.
            //
            // ag-grid may call this with either data undefined or data being empty object
            // empty row data are also possible for pinned row, when no cell should be visible
            return classnames_1.default(classList, isTopPinned && isEmptyCell ? "gd-hidden-sticky-column" : null);
        }
        var dv = table.getDrillDataContext();
        var colDef = cellClassParams.colDef;
        var col = table.tableDescriptor.getCol(colDef);
        ts_invariant_1.invariant(!tableDescriptorTypes_1.isRootCol(col));
        var drillablePredicates = sdk_ui_1.convertDrillableItemsToPredicates(props.drillableItems);
        var isRowTotal = row.type === constants_1.ROW_TOTAL;
        var isRowSubtotal = row.type === constants_1.ROW_SUBTOTAL;
        var hasDrillableHeader = false;
        var cellAllowsDrill = !isEmptyCell || colDef.type === constants_1.MEASURE_COLUMN;
        if (!isRowTotal && !isRowSubtotal && cellAllowsDrill) {
            hasDrillableHeader = cellDrillabilityPredicate_1.isCellDrillable(col, row, dv, drillablePredicates);
        }
        var colIndex = table.tableDescriptor.getAbsoluteLeafColIndex(col);
        var measureIndex = tableDescriptorTypes_1.isSeriesCol(col) ? last_1.default(col.fullIndexPathToHere) : undefined;
        var isPinnedRow = cellClassParams.node.isRowPinned();
        var hiddenCell = !isPinnedRow && table.getGroupingProvider().isRepeatedValue(col.id, rowIndex);
        var rowSeparator = !hiddenCell && table.getGroupingProvider().isGroupBoundary(rowIndex);
        var subtotalStyle = row === null || row === void 0 ? void 0 : row.subtotalStyle;
        return classnames_1.default(classList, measureIndex !== undefined ? "gd-column-measure-" + measureIndex : null, cellUtils_1.getCellClassNames(rowIndex, colIndex, hasDrillableHeader), "gd-column-index-" + colIndex, isRowTotal ? "gd-row-total" : null, subtotalStyle ? "gd-table-row-subtotal gd-table-row-subtotal-" + subtotalStyle : null, hiddenCell ? "gd-cell-hide s-gd-cell-hide" : null, rowSeparator ? "gd-table-row-separator s-gd-table-row-separator" : null, isTopPinned && isEmptyCell ? "gd-hidden-sticky-column" : null);
    };
}
exports.cellClassFactory = cellClassFactory;
//# sourceMappingURL=cellClass.js.map